import { TrackEvent, useTracking } from '../../../apps/professional-app/fa/common/tracking'
import { type AIAgentType } from '../../../models/AIAgent'
import { type IntegrationServiceId } from '../../../common/integrations'
import { type UserActionPayload } from './model'

interface UserActionButtonTrackingDetails {
  agentType: AIAgentType
  actionType: UserActionPayload['type']
  serviceId?: IntegrationServiceId
}

export const useTrackUserActionButtonClick = (userActionButtonTrackingDetails: UserActionButtonTrackingDetails) => {
  const { trackingClient } = useTracking()

  return (button: 'save' | 'connect' | 'reconnect') => {
    trackingClient.track({ eventName: TrackEvent.AI_AGENT_USER_ACTION_BUTTON_CLICKED, eventDetails: { ...userActionButtonTrackingDetails, button } })
  }
}
